import { IPortfolioDistributionItem } from "../../../../services/ManagedPortfolioService";
import { TPositionsFunds, TPrincipalPositions, TWalletProductInfo } from "../types/PrincipalPositionTypes";

type TFormatPieDistributionDataProps = {
    principalPositions: TPrincipalPositions[];
    walletRelationsInfo: TWalletProductInfo[];
    fundType: string;
};

export const FormatPieDistributionData = ( { principalPositions, walletRelationsInfo, fundType } : TFormatPieDistributionDataProps) => {

    const dataCircle: IPortfolioDistributionItem[] = [];

    const groupByCountry = agruparFundsPorCountry2(principalPositions, walletRelationsInfo, fundType)

    groupByCountry.forEach((lista, clave) => {
        dataCircle.push({
            name: lista[0].exposure,
            value: lista.reduce((acc, current) => acc + current.weight, 0) * 100,
            level2: []
        })
    })

    const relevantData = dataCircle.filter(item => item.value > 0.1);
    const filterData = relevantData.filter(item => item.name !== "Other");
    const totalRelevantData = filterData.reduce((acc, current) => acc + current.value, 0);
    const valueOthers = 100 - totalRelevantData;
    
    filterData.push({
        name: "Others",
        value: valueOthers,
        level2: [{
            name: "others",
            value: valueOthers
        }]
    })
    
    const ordered = filterData.sort((a, b) => b.value - a.value);

    return ordered;
};

type TPositionConReferencia = TPositionsFunds & { principalIsin: string };

const agruparFundsPorCountry2 = (data: TPrincipalPositions[], walletInfo: TWalletProductInfo[], fundType: string) => {
  const agrupados = new Map<string, TPositionConReferencia[]>();

  data.forEach(principal => {
    const countryFunds = principal.positionsFunds.filter(position => position.fundType === fundType);
        countryFunds.forEach(positionFund => {
        const wallet = walletInfo.find(wallet => wallet.isin === principal.isin)

        
        const positionConRef = {
            ...positionFund,
            weight: wallet ? positionFund.weight * wallet?.weight : positionFund.weight,
            principalIsin: principal.isin,
        }

      if (!agrupados.has(positionFund.exposure)) {
        agrupados.set(positionFund.exposure, []);
      }
      agrupados.get(positionFund.exposure)!.push(positionConRef);
    });
  });

  return agrupados;
};